import { useState, useEffect } from "react";
import {
  BillingUser,
  BillingUserWithoutCommon,
} from "translations/src/models/billing";
import { authorizationService } from "shared-auth";
import { AccountTypeBillingTypeMap } from "config/common";
import { useParams } from "react-router-dom";
import { CheckoutType } from "services/applicationMap";

export default function useGetUserType() {
  const { type } = useParams<{ type: CheckoutType }>();
  const [userType, setUserType] = useState<BillingUserWithoutCommon>();

  useEffect(() => {
    if (type === CheckoutType.Change) {
      return setUserType(BillingUser.PerformerChange);
    }

    if (type === CheckoutType.Graduate) {
      // user will not have graduate member group when entering conversion flow
      return setUserType(BillingUser.GraduateTransfer);
    }

    authorizationService.getUser().then((user) => {
      if (!userType && user) {
        setUserType(
          AccountTypeBillingTypeMap[user.profile["spotlight.MemberGroups"]]
        );
      }
    });
  }, [type, userType]);

  return userType;
}
